import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import {Tag} from "antd";
import React from "react";

const ItemTransformModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    
    columns.push({key:'origItem.itemNo', dataIndex: ['origItem', 'itemNo'], width: 150, filter:true, sorter:true, title:<Trans>Original Item No</Trans>});
    
    columns.push({key:'origItem.name', dataIndex: ['origItem', 'name'], width: 200, filter:true, sorter:true, title:<Trans>Original Item Name</Trans>});
    
    columns.push({key:'newItem.itemNo', dataIndex: ['newItem', 'itemNo'], width: 150, filter:true, sorter:true, title:<Trans>New Item No</Trans>});
    
    columns.push({key:'newItem.name', dataIndex: ['newItem', 'name'], width: 200, filter:true, sorter:true, title:<Trans>New Item Name</Trans>});
    
    columns.push({key:'quantity', width: 120, filter:true, sorter:true, title:<Trans>Quantity</Trans>});
    
    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true, title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, filter:true, sorter:true, title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateTimeFilter:true, sorter:true, title:<Trans>Created Date</Trans>, direction:"desc"});
    columns.push({key:'createdBy', width: 150, filter:true, sorter:true, title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/item-transforms"
    };
}
export default ItemTransformModel();
